import { initializeApp } from "firebase/app";
import keys from "./keys";

const firebaseApp = initializeApp(keys.firebase.prod);
console.log(firebaseApp.options.projectId);

// domain
const domain = "toonkids.com";
const domainUrl = "https://"+domain;

// storage
const bucketName = "storage"+"."+domain;
const storageDomain = 'https://'+bucketName;

//export
const Config = {
    domain: domainUrl,
    storageDomain: storageDomain
}
export default Config;